export default __webpack_public_path__ + "static/media/466fe6f33cc863a1273fa5b7aa9506dc.svg";